export const YOUTUBE_REGEX = /^(https?:\/\/)?(www\.|music\.)?(youtube\.com|youtu\.be)(.+)?$/;
export const FIGMA_REGEX =
  /https:\/\/([\w.-]+\.)?figma.com\/(file|proto)\/([0-9a-zA-Z]{22,128})(?:\/.*)?$/g;
export const LOOM_REGEX =
  /https:\/\/([\w.-]+\.)?loom.com\/(embed|share)\/([0-9a-zA-Z]{22,128})(?:\/.*)?$/g;

// Eg.
// https://player.vimeo.com/video/524933864
// https://vimeo.com/video/524933864
export const VIMEO_REGEX = /^(https?:\/\/)?(player\.)?(vimeo\.com)\/(video\/)?(.+)?$/g;
export const GRAPHY_REGEX = /^(https?:\/\/)?(share\.graphy\.app)\/(workspace\/)?(.+)?$/g;

export const CODESANDBOX_REGEX = /^(https?:\/\/)?(codesandbox\.io)\/(embed\/)?(.+)?$/g;
export const RIVE_REGEX = /^https?:\/\/?rive\.app\/(s|community)\/?(.+)?\/embed$/g;

export const enum EmbedProvider {
  youtube = "youtube",
  spotify = "spotify",
  loom = "loom",
  figma = "figma",
  vimeo = "vimeo",
  graphy = "graphy",
  codesandbox = "codesandbox",
  rive = "rive",
}

export const isValidYoutubeURL = (url: string) => url.match(YOUTUBE_REGEX);
export const isValidFigmaURL = (url: string) => url.match(FIGMA_REGEX);
export const isValidLoomURL = (url: string) => url.match(LOOM_REGEX);
export const isValidVimeoURL = (url: string) => url.match(VIMEO_REGEX);
export const isValidGraphyURL = (url: string) => url.match(GRAPHY_REGEX);
export const isValidCodeSandboxURL = (url: string) => url.match(CODESANDBOX_REGEX);
export const isValidRiveURL = (url: string) => url.match(RIVE_REGEX);

export const allValidEmbedURLs = [
  isValidYoutubeURL,
  isValidFigmaURL,
  isValidLoomURL,
  isValidVimeoURL,
  isValidGraphyURL,
  isValidCodeSandboxURL,
  isValidRiveURL,
];

export interface GetEmbedUrlOptions {
  url: string;
  controls?: boolean;
  nocookie?: boolean;
  startAt?: number;
  autoplay?: boolean;
}

export const getYoutubeEmbedUrl = (nocookie?: boolean) => {
  return nocookie ? "https://www.youtube-nocookie.com/embed/" : "https://www.youtube.com/embed/";
};

export const createLoomEmbedURL = (uuid: string) => `https://www.loom.com/embed/${uuid}`;

export const createFigmaEmbedURL = (url: string) =>
  `https://www.figma.com/embed?embed_host=outverse&url=${url}`;

export const createVimeoEmbedURL = (uuid: string) => `https://player.vimeo.com/video/${uuid}`;

export const getEmbedURLFromYoutubeURL = (options: GetEmbedUrlOptions) => {
  const { url, controls, nocookie, startAt, autoplay } = options;

  let outputUrl = "";

  // if is already an embed url, return it
  if (url.includes("/embed/")) {
    return url;
  }

  // if is a youtu.be url, get the id after the /
  if (url.includes("youtu.be")) {
    const id = url.split("/").pop();

    if (!id) {
      return "";
    }
    outputUrl = `${getYoutubeEmbedUrl(nocookie)}${id}`;
  } else {
    const videoIdRegex = /v=([-\w]+)/gm;
    const matches = videoIdRegex.exec(url);

    if (!matches || !matches[1]) {
      return "";
    }

    outputUrl = `${getYoutubeEmbedUrl(nocookie)}${matches[1]}`;
  }

  const params = [];

  if (!controls) {
    params.push("controls=0");
  }

  if (startAt) {
    params.push(`start=${startAt}`);
  }
  if (autoplay) {
    params.push(`autoplay=1`);
  }

  if (params.length) {
    outputUrl += `?${params.join("&")}`;
  }
  return outputUrl;
};
